<template>
  <div class="help">
    <div class="max-width">
      <div class="subs">
        <router-link to="/" class="subs__links">Home</router-link>
        <span>Help Center</span>
      </div>

      <div class="help__head">
        <div class="section__head section__head_middle">
          <div class="section__subheading section__subheading_themes fadeIn">Help</div>
          <h1 class="section__title">Center</h1>
          <div class="section__text">Explore our detailed documentation and benefit from support.</div>
        </div>
      </div>

      <div class="help__container">
        <div class="help__grid">
          <div
              v-for="doc in docs"
              :key="doc.link"
              class="help__item fadeIn"
          >
            <div class="help__icon">
              <img src="@/assets/imgs/file.svg" alt="">
            </div>
            <h3 class="help__title">{{ doc.title }} Theme</h3>
            <a :href="doc.link" class="button" target="_blank">
              View Documentation
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.59844 4.2002L11.3984 9.0002L6.59844 13.8002" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>

      </div>

      <SupportView/>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useHead } from '@vueuse/head'
import SupportView from '@/components/SupportView.vue'

useHead({
  title: 'Help Center – Almost Perfect Studio',
  meta: [
    { name: 'description', content: 'Explore the Almost Perfect Studio Help Center for guides, tutorials, and expert tips to fix bugs, customize, and optimize your Shopify themes.' }
  ]
})

const docs = ref([])
const listId = 'help'

onMounted(async () => {
  const res = await fetch('/assets/json/docs.json')
  const data = await res.json()
  docs.value = data.filter(d => !d.hiddenIn?.includes(listId))
})
</script>

<style lang="scss">
.help {
  &__container {
    display: flex;
    gap: 7.5rem;
    flex-direction: column;

    @include xs {
      gap: 4rem;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;

    @include md {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    padding: 2.5rem;
    background: #fff;
    border-radius: 24px;

    @include xs {
      padding:1.5rem;
    }
  }

  &__icon {
    margin:0 0 3.5rem;

    @include xs {
      margin:0 0 2rem;

      img,svg {
        height:3rem;
        width:auto;
      }
    }
  }

  &__title {
    margin: 0 0 1rem;
    font-family: var(--font-family);
    font-size: 1.5rem;
    font-weight: 900;
    line-height:1.3;
    letter-spacing: -0.01em;
    text-transform: uppercase;

    @include xs {
      font-size:1.25rem;
    }
  }
}
</style>
